import {
    ManufacturerApiModel,
    ModelNumberApiModel,
    ModelSeriesApiModel,
} from '../../common/api/equipments.api';

export interface EquipmentManufacturer {
    id: string;
    text: string;
    label: string;
}

export interface EquipmentModelSeries {
    id: string;
    text: string;
    label: string;
    manufacturer: EquipmentManufacturer;
}

export interface EquipmentModelNumber {
    id: string;
    text: string;
    label: string;
    hasDocumentation: boolean;
    modelSeries: EquipmentModelSeries;
    modelImage: string;
    brandeImage: string;
    notes: string;
}

export const toManufacturerViewModel = (apiModel: ManufacturerApiModel): EquipmentManufacturer => {
    return {
        ...apiModel,
        label: apiModel.text,
    };
};

export const toManufacturerApiModel = (
    viewModel?: EquipmentManufacturer
): ManufacturerApiModel | undefined => {
    if (!viewModel) {
        return undefined;
    }
    return {
        id: viewModel.id,
        text: viewModel.text,
    };
};

export const toModelSeriesViewModel = (apiModel: ModelSeriesApiModel): EquipmentModelSeries => {
    return {
        ...apiModel,
        label: apiModel.text,
        manufacturer: toManufacturerViewModel(apiModel.manufacturer),
    };
};

export const toModelSeriesApiModel = (
    viewModel?: EquipmentModelSeries
): ModelSeriesApiModel | undefined => {
    if (!viewModel) {
        return undefined;
    }
    return {
        id: viewModel.id,
        text: viewModel.text,
        manufacturer: toManufacturerApiModel(viewModel.manufacturer)!,
    };
};

export const toModelNumberViewModel = (apiModel: ModelNumberApiModel): EquipmentModelNumber => {
    return {
        ...apiModel,
        label: `${apiModel.text} ${apiModel.model_notes ? ` - ${apiModel.model_notes}` : ''}`,
        hasDocumentation: apiModel.has_document_coverage,
        modelSeries: toModelSeriesViewModel(apiModel.model_series),
        brandeImage: apiModel.manufacturer_image,
        modelImage: apiModel.model_image,
        notes: apiModel.model_notes ?? '',
    };
};
